webpackJsonp([7954945660500],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wichitaImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WichitaLocation = function (_React$Component) {
	  _inherits(WichitaLocation, _React$Component);
	
	  function WichitaLocation() {
	    _classCallCheck(this, WichitaLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WichitaLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Wichita, KS' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Take the Plunge',
	        story: ['The PeopleForBikes blog is the place to go for stories about infrastructure, business, political issues and stories about everyday bike riders. One of our most popular posts of 2017 told the story of a bike lane in Wichita, Kansas. Two weeks after an anonymous group of activists dropped toilet plungers along a bike lane to create protection from vehicles, the city installed permanent flexposts to make the route safer. Other popular posts told tales of mountain bike trails in Minnesota, AAA on-the-road bike service and e-bike myths. ', _react2.default.createElement(
	          'a',
	          { href: 'https://peopleforbikes.org/blog/', target: '_blank' },
	          'Click here'
	        ), ' to see what else was top of the blog in 2017.']
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Wichita',
	        alt: 'Cyclofest expo picture',
	        sizes: this.props.data.wichitaImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'St. Pete Beach, FL',
	        prevLocationPath: 'st-pete-beach',
	        prevLocationImgPath: this.props.data.wichitaPrevImage,
	        nextLocationName: 'Arizona',
	        nextLocationPath: 'arizona',
	        nextLocationImgPath: this.props.data.wichitaNextImage
	      })
	    );
	  };
	
	  return WichitaLocation;
	}(_react2.default.Component);
	
	exports.default = WichitaLocation;
	var wichitaImageQuery = exports.wichitaImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-wichita-js-db30cac9cc04ae41ea7b.js